module.exports = __webpack_public_path__ + "img/open-link.193b4c0c.svg";